import { useEffect, useRef } from 'react';

/**
 * Runs `onRestore` when the page is restored from the back/forward cache (bfcache) — e.g. the
 * user hit Back after navigating away. Listens on both `pagehide` (fires on the way out, so
 * resetting there can avoid a flash of stale UI) and `pageshow` (the guaranteed fallback, in
 * case the pagehide-time update didn't paint before the page was frozen).
 */
export function useBfcacheRestore(onRestore: () => void) {
  const onRestoreRef = useRef(onRestore);
  onRestoreRef.current = onRestore;
  useEffect(() => {
    const handlePersisted = (event: PageTransitionEvent) => {
      if (event.persisted) {
        onRestoreRef.current();
      }
    };
    window.addEventListener('pagehide', handlePersisted);
    window.addEventListener('pageshow', handlePersisted);
    return () => {
      window.removeEventListener('pagehide', handlePersisted);
      window.removeEventListener('pageshow', handlePersisted);
    };
  }, []);
}